import isNumber from "lodash-es/isNumber";
import memoize from "lodash-es/memoize";

const parseSizeToNumber = (value: string) => {
  if (/(\d.*)px/.test(value)) {
    return Number(value.replace("px", ""));
  } else if (isNumber(parseSizeToNumber)) {
    return value;
  }

  return undefined;
};

const getImageDimensions = (src: string) => {
  if (!src) {
    return undefined;
  }

  return new Promise<{ height: number; width: number }>((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        height: img.height,
        width: img.width,
      });
    img.onerror = (error) => {
      reject(
        new Error(
          `Failed to load image dimensions from ${src}. This may be due to CORS restrictions, invalid URL, or network error.`
        )
      );
    };
    img.src = src;
  });
};

// returns in bytes = 10^(-6) MB
const getResourceSize = memoize((src: string) => {
  return new Promise<{ resourceDetails: Blob }>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", src, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ resourceDetails: xhr.response as Blob });
      } else {
        reject(
          new Error(
            `Failed to fetch resource from ${src}. HTTP status: ${xhr.status}. This may be due to CORS restrictions, invalid URL, or network error.`
          )
        );
      }
    };
    xhr.onerror = () => {
      reject(
        new Error(
          `Network error while fetching resource from ${src}. This may be due to CORS restrictions, invalid URL, or network connectivity issues.`
        )
      );
    };
    xhr.onabort = () => {
      reject(new Error(`Request to ${src} was aborted.`));
    };
    xhr.ontimeout = () => {
      reject(new Error(`Request to ${src} timed out.`));
    };
    xhr.send();
  });
});

export { getImageDimensions, getResourceSize, parseSizeToNumber };
